import { Link } from 'react-router-dom';
import { promotions } from '@/mocks/data';

const promoImages = [
  'https://readdy.ai/api/search-image?query=Luxury%20golden%20and%20dark%20themed%20promotional%20banner%20with%20elegant%20geometric%20patterns%2C%20premium%20reward%20atmosphere%2C%20warm%20golden%20accents%20on%20dark%20background%2C%20celebratory%20and%20exclusive%20feel%2C%20sophisticated%20marketing%20visual&width=800&height=600&seq=promo-newbie-2026&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Elegant%20daily%20rewards%20promotion%20banner%20with%20golden%20coins%20and%20luxury%20elements%20on%20dark%20sophisticated%20background%2C%20premium%20gaming%20atmosphere%2C%20warm%20golden%20glow%2C%20high-end%20visual%20style&width=800&height=600&seq=promo-daily-2026&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Weekly%20cashback%20promotional%20banner%20with%20golden%20ribbons%20and%20luxurious%20design%20elements%20on%20dark%20elegant%20background%2C%20premium%20reward%20celebration%20theme%2C%20sophisticated%20marketing%20aesthetic&width=800&height=600&seq=promo-weekly-2026&orientation=landscape',
];

export default function PromotionSection() {
  return (
    <section className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-xs md:text-sm font-medium text-accent-500 tracking-widest uppercase mb-2" style={{ fontFamily: "var(--font-label)" }}>
            限时优惠
          </p>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
            超值福利，不容错过
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-xl mx-auto">
            必赢亚洲持续推出丰厚优惠活动，让您的每一次体验都物超所值
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {promotions.map((promo, index) => (
            <Link
              key={index}
              to="/category/promotions"
              className="group block relative rounded-xl overflow-hidden h-64 md:h-72"
            >
              <img
                src={promoImages[index]}
                alt={promo.title}
                className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <span className="inline-block px-3 py-1 rounded-full bg-accent-500 text-white text-xs font-semibold mb-2">
                  {promo.tag}
                </span>
                <h3 className="text-lg md:text-xl font-bold text-white mb-1" style={{ fontFamily: "var(--font-heading)" }}>
                  {promo.title}
                </h3>
                <p className="text-xs md:text-sm text-white/70 leading-relaxed">
                  {promo.description}
                </p>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-8 md:mt-10">
          <Link
            to="/category/promotions"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full border-2 border-primary-500 text-primary-500 font-semibold text-sm hover:bg-primary-500 hover:text-white transition-all duration-200 whitespace-nowrap"
          >
            查看全部优惠
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}